import { useEnsuredContext } from '~/utilities/hooks.utility';
import { MusicPlayerStateContext } from './music-player.context';

export const useMusicPlayerState = () =>
  useEnsuredContext(MusicPlayerStateContext);
